<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 40 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9377 6.65829C18.6425 10.1404 16.3575 15.164 10.3666 14.0562M12.0243 8.68279C13.7114 6.70146 17.8062 5.88589 22.6668 7.55052C24.7691 8.12673 29.3064 10.3734 31.389 12.0331C33.9308 13.7238 37.5506 17.3112 38.4954 21.0409C39.5269 24.4758 37.9281 29.6556 32.9087 33.0522C28.1085 36.3006 21.3828 36.385 14.8545 26.2577C14.6142 26.2577 7.10602 14.0431 12.0243 8.68279Z"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.00127 21.9343C4.89093 21.1517 9.314 23.529 8.55515 29.3295M29.2221 10.0799C29.2221 9.72207 28.4457 7.91242 27.6789 6.96893C24.2255 1.99734 19.1033 0.207718 15.5054 1.31954C11.7731 2.25373 8.20088 5.73146 6.50294 8.26846C4.49553 10.7083 2.49896 14.8925 1.91677 16.9932C0.238322 21.8491 1.02123 26.0482 2.99769 27.741C4.29175 28.9466 8.40882 30.6345 14.5247 27.741"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.0098 19.9318C18.0098 19.9318 18.0084 22.244 20.3095 22.2431C22.6107 22.2421 22.6096 24.554 22.6096 24.554M23.6959 14.2192C23.6959 14.2192 23.6946 16.5314 25.9956 16.5305C28.2969 16.5296 28.2958 18.8412 28.2958 18.8412M26.6344 22.8218C26.6344 22.8218 26.6331 25.1338 28.9341 25.1328C31.2354 25.1319 31.2342 27.4437 31.2342 27.4437"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
